@if (workspace()?.uiComponents?.length || wizardMode()) {
  @if (displayedComponents().length) {
    <div
      class="w-full flex-1 grid overflow-hidden p-[2px]"
      [style.grid-template-columns]="panelGridTemplateColumns()"
      [style.grid-template-rows]="panelGridTemplateRows()"
      #panelGrid>
      @for (item of displayedComponents(); track item.id; let i = $index) {
        <div
          class="relative min-w-0 min-h-0 overflow-hidden border border-[var(--p-content-border-color)] bg-[var(--p-content-background)] flex flex-col will-change-transform"
          [style.grid-column]="getPanelItemGridColumn(i)"
          [style.grid-row]="getItemGridRow(i)">
          <div class="flex justify-between items-center px-2 bg-[var(--p-content-hover-background)] select-none flex-shrink-0">
            <span class="text-xs">{{ item.name }}{{ stringDependentComponents().includes(item.name) ? (!item.name.startsWith('Drill String') ? currentStringName() : holeSectionName()) : '' }}</span>
            <div class="flex items-center">
              @if (item.name == componentInstance()) {
                <span class="pi pi-save text-green-400 pr-1"></span>
              }
              @if (!wizardMode()) {
                <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" severity="danger" (onClick)="componentRemoved.emit(item)"></p-button>
              }
            </div>
          </div>
          <div class="flex-1 min-h-0 overflow-hidden" #panelCellContent>
            <fieldset pFocusTrap class="border-none m-0 h-full" [disabled]="userRoles()?.readOnly">
              <ndc-dynamic
                [ndcDynamicComponent]="item.componentInstance"
                [ndcDynamicInputs]="{ componentId: item.id }">
              </ndc-dynamic>
            </fieldset>
          </div>
        </div>
      }
      @if (!wizardMode()) {
        <!-- Row resize handles -->
        @for (rowIdx of panelRowHandleIndices(); track rowIdx) {
          <div
            class="cursor-row-resize select-none transition-colors z-10"
            [style.grid-row]="rowIdx * 2 + 2"
            [style.grid-column]="'1 / -1'"
            (mousedown)="startRowResize($event, rowIdx)">
          </div>
        }
        <!-- Column resize handles -->
        @for (colIdx of panelColHandleIndices(); track colIdx) {
          <div
            class="cursor-col-resize select-none transition-colors z-10"
            [style.grid-column]="colIdx * 2 + 2"
            [style.grid-row]="'1 / -1'"
            (mousedown)="startColResize($event, colIdx)">
          </div>
        }
      }
    </div>
  }
} @else {
  <div class="h-full flex flex-col items-center justify-center gap-3 opacity-40">
    <i class="pi pi-objects-column text-4xl"></i>
    <span class="text-sm">Select components to add to the panel</span>
  </div>
}
